/**
 * @file      Math.ts
 * @author    Gage Sorrell <gage@sorrell.sh>
 * @copyright (c) 2026 Gage Sorrell
 * @license   MIT
 */
/* eslint-disable */
export const __DummyExport_Number: "DummyExport" = "DummyExport" as const;
